

























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { FramePuzzleModule, PuzzleFormat } from '../../../../store/modules/framePuzzle';
import FramePuzzleEditorPassive from "@/components/products/framepuzzle/FramePuzzleEditorPassive.vue"
import FrameImageBig from '@/components/products/framepuzzle/FrameImageBig.vue'

@Component({
  name: "box-edit-big",
  components: {
    FramePuzzleEditorPassive,
    FrameImageBig
  }
})
export default class BoxEditBig extends Vue {
  transformedOffsetX: number = 0
  transformedOffsetY: number = 0

  get isLandscapeFormat() {
    return FramePuzzleModule.isLandscapeFormat
  }

  /*  imageRatio for 25 and 73 parts is 250x330mm = 0.75(75)
        however the image ratio of the user image inside print data is 2953x3921px = 0.753
        therefore we adjust the scaling for the longer side to
        present the preview as close to the final print data as possible
  */

  get editorScaleX() {
    if (this.isLandscapeFormat) {
      return 0.891 //(3921/4512) * (410/400) = userImgWidth/FrameWidth * frameImgWidth/EditorWidth
    } else {
      return 0.74
    }
  }

  get editorScaleY() {
    if (this.isLandscapeFormat) {
      return 0.886
    } else {
      return 0.745
    }
  }

  setUserImg() {
    this.setTransformedOffsetX()
    this.setTransformedOffsetY()
  }

  setTransformedOffsetX() {
    if (this.isLandscapeFormat) {
      this.transformedOffsetX = 5.5
    } else {
      this.transformedOffsetX = -16
    }
  }

  setTransformedOffsetY() {
    if (this.isLandscapeFormat) {
      this.transformedOffsetY = 58.5
    } else {
      this.transformedOffsetY = 10
    }
  }

  get imageEditorWidth() {
    return FramePuzzleModule.imageEditorWidth
  }

  get imageEditorHeight() {
    return FramePuzzleModule.imageEditorHeight
  }

  get format() {
    if (FramePuzzleModule.format === PuzzleFormat.LANDSCAPE) {
      return 'landscape'
    }
    return 'portrait'
  }

  mounted() {
    this.setUserImg()
  }
}
